import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import dasherize2 from '../../utilities/dasherize'
import styled from 'styled-components'

const List = () => {
  const { allGoogleSpreadsheetCat, allGoogleSpreadsheetExc } = useStaticQuery(
    graphql`
      query {
        allGoogleSpreadsheetCat(sort: { fields: categor_a, order: ASC }) {
          nodes {
            id
            categoria: categor_a
            marca
          }
        }
        allGoogleSpreadsheetExc(sort: { fields: marca, order: ASC }) {
          nodes {
            id
            marca
          }
        }
      }
    `,
  )

  const Summary = styled.div`
    background-color: white;
    border-radius: 0.5rem;
    padding: 2rem;

    .list > ul {
      > li {
        position: relative;
        &::before {
          content: ' ';
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='black'/%3E%3C/svg%3E");
          width: 0.8em;
          height: 0.8em;
          display: inline-block;
          margin-right: 0.3em;
          position: absolute;
          top: 0.4em;
        }
        > a {
          display: inline-block;
          border-bottom: 1px solid #ccc;
          width: calc(100% - 1.5em);
          &:hover {
            background-color: #f5f5f5;
          }
          margin-left: 1.2em;
        }
        > ul {
          > li {
            margin-left: 1.5rem;
            position: relative;
            > a {
              display: inline-block;
              border-bottom: 1px solid #ccc;
              width: calc(100% - 1.5em);
              &:hover {
                background-color: #f5f5f5;
              }
              margin-left: 1.2em;
            }
            &::before {
              content: ' ';
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='black'/%3E%3C/svg%3E");
              width: 0.8em;
              height: 0.8em;
              display: inline-block;
              margin-right: 0.3em;
              position: absolute;
              top: 0.4em;
            }
          }
        }
      }
    }
  `

  return (
    <Summary>
      <div className="container mx-auto my-5 text-left">
        <h1 className="text-center">
          <strong>Ganadores</strong>
        </h1>
        <div className="list">
          <ul>
            <li>
              <Link to="/marcas-de-excelencia/">Marcas de excelencia</Link>
              {allGoogleSpreadsheetExc?.nodes.map(node => (
                <ul key={node.id} className="withCols">
                  <li>
                    <Link
                      key={node.id}
                      className="block"
                      to={`/marcas-de-excelencia/${dasherize2(node.marca)}/`}>
                      {node.marca}
                    </Link>
                  </li>
                </ul>
              ))}
            </li>
            <li>
              <Link to="/ganadores-por-categoria/">
                Ganadores por Categoría
              </Link>
              {allGoogleSpreadsheetCat?.nodes.map(node => (
                <ul key={node.id} className="withCols">
                  <li>
                    <Link
                      key={node.id}
                      className="block"
                      to={`/ganadores-por-categoria/${dasherize2(
                        node.marca,
                      )}-${dasherize2(node.categoria)}/`}>
                      {node.categoria} - {node.marca}
                    </Link>
                  </li>
                </ul>
              ))}
            </li>
          </ul>
        </div>
      </div>
    </Summary>
  )
}

export default List
